export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_MANAGER = 'ROLE_MANAGER';
export const ROLE_VENTE = 'ROLE_VENTE';
export const ROLE_STOCK = 'ROLE_STOCK';
export const ROLE_PROD = 'ROLE_PROD';
export const ROLE_SUIVI = 'ROLE_SUIVI';

export const ROUTE_LOGIN = 'login';
